import {NgModule} from '@angular/core';
import {CmsConfig, I18nConfig, provideConfig} from '@spartacus/core';
import {
  configuratorTranslationChunksConfig,
  configuratorTranslationsDe,
  configuratorTranslationsEn,
} from '@spartacus/product-configurator/common/assets';
import {
  PRODUCT_CONFIGURATOR_RULEBASED_FEATURE,
  RulebasedConfiguratorRootModule,
} from '@spartacus/product-configurator/rulebased/root';
import {RulebasedConfiguratorModule} from '@spartacus/product-configurator/rulebased';
import {DcpCpsProductConfiguratorModule} from '@app/product/configurator/configurator-components/cps-configurator/dcp-cps-product-configurator.module';

@NgModule({
  declarations: [],
  imports: [RulebasedConfiguratorRootModule, RulebasedConfiguratorModule, DcpCpsProductConfiguratorModule],
  providers: [
    provideConfig({
      featureModules: {
        featureModules: {
          [PRODUCT_CONFIGURATOR_RULEBASED_FEATURE]: {
            module: () =>
              import('../../../product/configurator/configurator-components/cps-configurator/dcp-cps-product-configurator.module').then(
                (m) => m.DcpCpsProductConfiguratorModule,
              ),
          },
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: configuratorTranslationsEn, de: configuratorTranslationsDe},
        chunks: configuratorTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class ProductConfiguratorFeatureModule {}
